import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchAccommodationGuestDetails } from '@/renderer/services/accommodationService';

export function useGuestDetails(
  guestId: string | null | undefined,
  outletId?: string | null,
) {
  return useQuery({
    queryKey: queryKeys.accommodation.guestDetails(guestId ?? '', outletId),
    queryFn: () => fetchAccommodationGuestDetails(guestId!, outletId),
    enabled: !!guestId,
  });
}
